import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";
import Image from "@/ui/Image";
import classes from "./styles.module.scss";
import clsx from "classnames";

export const EventsPageBannerSection = ({ className }) => {
  const locale = useLocale();

  return (
    <Banner
      className={clsx(className, classes.banner)}
      image={{ path: "page.events.banner.bg.image", src: "/assets/banners/default.webp" }}
      title={<DynamicText path={`page.events.banner.title.${locale}`} tag="h1" />}
      alt={<DynamicText path={`page.events.banner.title.${locale}`} tag="h1" />}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.events.banner.description.${locale}`} />
        </Col>
        <Col xs={12} md={6}>
          <Image
            className={classes.banner__image}
            img={{ path: "page.events.banner.image", src: "/assets/events/banner/1.png" }}
            size="667x662"
            alt=""
          />
        </Col>
      </Row>
    </Banner>
  );
};
